export { default } from './SearchResultItem';
